import { combine, withContext, withAsyncEffect } from 'react-hooks-combine'
import { StoreContext } from 'store/context'

import TournamentGamesTabComponent from './component'

export const TournamentGamesTab = combine({
	hooks: [
		withContext('eventsStore', StoreContext, ({ events }) => events),
		withAsyncEffect({
			deps: ['tournamentId'],
			dataName: 'games',
			loadingName: 'loading',
			errorName: 'error',
			async asyncAction({ eventsStore }, { tournamentId }) {
				if (!tournamentId) {
					return []
				}

				try {
					// Get current date to filter out past games
					const currentDate = Date.now()
					
					// Load events for this tournament (today and future only)
					const { events } = await eventsStore.load({
						tournamentId,
						size: 100, // Load a large number of games for the tournament
						page: 0,
						sort: 'startTime,asc',
						startTimeEqOrGreater: currentDate, // Only get games from today onwards
						resolvedStatus: 'NOT_RESOLVED' // Only get unresolved games
					})

					return events || []
				} catch (error) {
					console.error('Failed to load tournament games:', error)
					throw new Error('Failed to load tournament games')
				}
			},
		}),
	],
})(TournamentGamesTabComponent) 